import Vue from 'vue';
import Vuex from 'vuex';

// Utils
import CookieUtil from '@/utils/CookieUtil';

// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import modules from './modules';

Vue.use( Vuex );

const actionTypes = {
    setUserLocationGetWebsiteInfoGoHome: 'setUserLocationGetWebsiteInfoGoHome',

    postLoginHooks: 'postLoginHooks',

    dialog: 'dialog',
    clearDialog: 'clearDialog',
    snackbar: 'snackbar',
    clearSnackbar: 'clearSnackbar',
    reset: 'reset',
};

const mutationTypes = {
    SET_DIALOG: 'SET_DIALOG',
    SET_SNACKBAR: 'SET_SNACKBAR',
};

export default new Vuex.Store( {
    // https://vuex.vuejs.org/en/strict.html
    strict: process.env.NODE_ENV !== 'production',
    modules,
    state: {
        dialog: null,
        snackbar: null,
    },
    getters: {
        /** @returns { Boolean } */
        hasDialog: ( state ) => state.dialog !== null,
        /** @returns { Boolean } */
        hasSnackbar: ( state ) => state.snackbar !== null,
    },
    mutations: {
        [ mutationTypes.SET_DIALOG ]( state, value ) {
            state.dialog = value;
        },
        [ mutationTypes.SET_SNACKBAR ]( state, value ) {
            state.snackbar = value;
        },
    },
    actions: {
        [ actionTypes.reset ]( { dispatch } ) {
            dispatch( actionTypes.clearSnackbar );
            dispatch( actionTypes.clearDialog );
        },

        async [ actionTypes.setUserLocationGetWebsiteInfoGoHome ]( context, {
            locationId,
            locationName,
            locationNameFriendly,
            websiteId,
        } ) {
            try {
                context.commit( 'User/SET_SELECTED_LOCATION', {
                    id: locationId,
                    name: locationName,
                    nameFriendly: locationNameFriendly,
                    websiteId,
                } );
                await context.dispatch( 'Website/getInfo', { websiteId } );
                await context.dispatch( actionTypes.postLoginHooks );
                // Go home if we're on login for some reason...
                if ( router.history.current.path === '/login' ) {
                    const toRoute = CookieUtil.getLandingPageCookieValue() || '/';
                    await router.push( { path: toRoute } ).catch( ( stupidError ) => {
                        console.error( "We're going home, we're running free...", stupidError );
                    } );
                }
            } catch ( error ) {
                console.error( 'Error in setUserLocationGetWebsiteInfoGoHome: ', error );
                // Route to Login
                // router.push( { path: '/login' } ).catch( ( stupidError ) => {
                //     console.error( 'Login failure - redirect failure: ', stupidError );
                // } );
                // Throw error
                throw error;
            }
        },

        /**
         * Only AWAIT on things that are mission-critical, otherwise they will block the login process
         */
        async [ actionTypes.postLoginHooks ]( context ) {
            context.dispatch( 'Mail/getAllLists', {}, { root: true } );
        },
        [ actionTypes.dialog ]( { commit }, payload ) {
            commit( mutationTypes.SET_DIALOG, {
                title: payload.title || '',
                message: payload.message || '',
                cancelText: payload.cancelText || '',
                confirmText: payload.confirmText || 'Ok',
                type: payload.type && [ 'info', 'warning', 'error', 'success' ].includes( payload.type )
                    ? payload.type
                    : 'primary',
                onCancel: payload.onCancel || null,
                onConfirm: payload.onConfirm || null,
                persistent: payload.persistent || false,
                width: payload.width || 'auto',
                closable: payload.closable || true,
            } );
        },
        [ actionTypes.clearDialog ]( { commit } ) {
            commit( mutationTypes.SET_DIALOG, null );
        },

        [ actionTypes.snackbar ]( { commit }, payload ) {
            commit( mutationTypes.SET_SNACKBAR, {
                message: payload.message || '',
                type: payload.type && [ 'info', 'warning', 'error', 'success' ].includes( payload.type )
                    ? payload.type
                    : 'primary',
                actionText: payload.actionText || '',
                onAction: payload.onAction || null,
                // default to indefinite
                duration: payload.duration || -1,
                height: payload.height || undefined,
                width: payload.width || undefined,
                // default to position top
                top: payload.top || true,
                right: payload.right || false,
                bottom: payload.bottom || false,
                left: payload.left || false,
            } );
        },
        [ actionTypes.clearSnackbar ]( { commit } ) {
            commit( mutationTypes.SET_SNACKBAR, null );
        },
    },
} );
